import React from 'react';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';

import FilterForm from '../../../../../components/form/base/FilterForm';
import TextField from '../../../../../components/form/elements/TextField';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../../../../../components/form/enum/formProps';
import { KeywordFilterValues } from '../../../model/keywordModel';
import * as Actions from '../../../redux/keywordActions';
import useDataGridProgressContext from '../../../../../components/progress/DataGridProgress/context/DataGridProgressContext';
import { objectHelper } from '../../../../../shared/utils/objectHelper';

const initialValues: KeywordFilterValues = {
  id: '',
  name: '',
};

const validationSchema = Yup.object().shape({
  id: Yup.number().min(1, 'validation.too_small'),
  name: Yup.string().min(2, 'validation.too_short'),
});

const KeywordFilter: React.FC = () => {
  const dispatch = useDispatch();
  const dataGridProgressContext = useDataGridProgressContext();

  return (
    <FilterForm<KeywordFilterValues>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values: KeywordFilterValues) => {
        dataGridProgressContext.show();
        dispatch(Actions.getAllKeywords(objectHelper.removeEmptyValues<KeywordFilterValues>(values)));
      }}
      disabled={dataGridProgressContext.visibility}
    >
      <TextField
        name="id"
        label="keyword.id"
        type={TEXT_FIELD_TYPE.NUMBER}
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
      <TextField
        name="name"
        label="keyword.name"
        type={TEXT_FIELD_TYPE.TEXT}
        color={TEXT_FIELD_COLOR.PRIMARY}
        variant={TEXT_FIELD_VARIANT.STANDARD}
      />
    </FilterForm>
  );
};

export default KeywordFilter;
